import styled from '@emotion/styled';
import { theme } from '~/theme';
import { motion } from 'framer-motion';
import { breakpoints } from '~/theme/breakpoints';
import { Link } from '~/shared/components';

export const SearchOverlayMain = styled.div({
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    gap: theme.space['3'],
    [breakpoints.sm]: {
        flexDirection: 'row',
    },
});

export const SearchOverlayContainer = styled(motion.div)(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    maxWidth: '690px',
    width: '100%',
    ['.no-results-header']: {
        fontSize: theme.fontSizes.md,
        lineHeight: theme.lineHeights.base,
        textAlign: 'center',
        marginBottom: theme.space['5'],
    },
    [breakpoints.sm]: {
        overflow: 'hidden',
    },
    [breakpoints.xs]: {
        marginTop: '24px',
    },
}));

export const SearchOverlayNoResultsContainer = styled(motion.div)(() => ({}));

export const StyledSearchedProductResultsContainer = styled.div(({ theme }) => ({
    backgroundColor: theme.colors.brownUltraLight,
    padding: '24px 15px 0 15px',
    marginLeft: '-15px',
    marginRight: '-15px',
    [breakpoints.sm]: {
        padding: '24px',
        margin: 0,
    },
}));

export const SearchOverlayFooter = styled.div({});

export const SearchOverlayButtonContainer = styled(motion.div)(() => ({
    textAlign: 'center',
    width: '100%',
    position: 'sticky',
    bottom: '0',
    backgroundColor: 'white',
    marginTop: 'auto',
    [breakpoints.sm]: {
        margin: 0,
    },
}));

export const SearchOverlayShortcutContainer = styled(motion.div)(() => ({}));

export const SearchOverlayHeading = styled.div(({ theme }) => ({
    textTransform: 'uppercase',
    fontSize: '14px',
    lineHeight: '20px',
    marginBottom: '16px',
    color: theme.colors.grey150,
}));

export const Hr = styled.hr(() => ({
    width: '100%',
    border: 'none',
    borderTop: `1px solid ${theme.colors.brownLight}`,
    margin: '0',
}));

export const StyledSearchProduct = styled.div(({ theme }) => ({
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    height: 'auto',
    minHeight: '73px',
    borderBottom: `1px solid ${theme.colors.brownLight}`,
    padding: '5px',
    figure: {
        width: '74px',
        height: '48px',
        marginRight: '16px',
        mixBlendMode: 'multiply',
    },
    '&:hover': {
        backgroundColor: theme.colors.grey20,
    },
}));

export const StyledSearchProductDetails = styled.div(() => ({
    display: 'flex',
    flexFlow: 'column',
    justifyContent: 'center',
    marginRight: '5px',
    p: {
        fontSize: `${theme.fontSizes.exs}`,
        lineHeight: `${theme.lineHeights.base}`,
        [breakpoints.sm]: {
            fontSize: `${theme.fontSizes['2xs']}`,
        },
    },
    '.product-name': {
        fontSize: `${theme.fontSizes['2xs']}`,
        lineHeight: `${theme.lineHeights.base}`,
        [breakpoints.sm]: {
            fontSize: `${theme.fontSizes.xs}`,
        },
    },
    '.ais-Highlight-highlighted': {
        backgroundColor: 'unset',
        fontWeight: `${theme.fontWeights.medium}`,
    },
}));

export const StyledSearchProductPrice = styled.div(({ theme }) => ({
    display: 'flex',
    flexFlow: 'column',
    marginLeft: 'auto',
    alignItems: 'flex-end',
    justifyContent: 'center',
    p: {
        fontSize: `${theme.fontSizes['2xs']}`,
        lineHeight: `${theme.lineHeights.base}`,
        [breakpoints.sm]: {
            fontSize: `${theme.fontSizes.xs}`,
        },
    },
    '.sale-price': {
        color: `${theme.colors.redMediumLight}`,
    },
    span: {
        marginLeft: '10px',
    },
}));

export const SearchOverlayPopularSearchesContainer = styled(motion.div)(() => ({
    display: 'flex',
    flexFlow: 'column',
    marginBottom: '24px',
}));

export const SearchOverlayPopularSuggestionsContainer = styled(motion.div)(() => ({
    display: 'flex',
    flexFlow: 'column',
    overflow: 'hidden',
    marginBottom: '24px',
}));

export const StyledSearchSuggestion = styled.span(({ theme }) => ({
    height: '53px',
    borderBottom: `1px solid ${theme.colors.brownLight}`,
    fontSize: `${theme.fontSizes.xs}`,
    lineHeight: `${theme.lineHeights.base}`,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    '&:hover': {
        backgroundColor: theme.colors.grey10,
    },
    '.ais-Highlight::first-letter': {
        textTransform: 'capitalize',
    },
    '.ais-Highlight-highlighted': {
        backgroundColor: 'unset',
        fontWeight: `${theme.fontWeights.medium}`,
    },
    [breakpoints.sm]: {
        paddingLeft: '8px',
    },
}));

export const SearchLink = styled(Link)(({ theme }) => ({
    display: 'block',
    color: theme.colors.black,
    ':hover': {
        color: theme.colors.black,
        textDecoration: 'none',
    },
    ':focus-visible': {
        boxShadow: theme.shadows.accessibilityInset,
    },
}));

export const StyledPrice = styled.span(() => ({
    textTransform: 'uppercase',
}));

export const StyledSearchForm = styled.form(() => ({
    display: 'flex',
    width: '100%',
    alignItems: 'center',
    flex: 1,
    minWidth: 0,
}));
